import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    return {
        templating: state.template,
    }
}

export default connect(mapStateToProps)
